export default [
	// can trigger report generation
	'bedc:report:admin/report',

	// can list reports
	'bedc:report:read/list',
	'bedc:report:list/assignees',

	//all of reports
	'bedc:report:read:{clientId}/totalJobs',

	'bedc:report:read:{clientId}/timePerJob',
	'bedc:report:read:column/timePerJob/targetAt',
	'bedc:report:read:column/timePerJob/totalM2',
	'bedc:report:read:column/timePerJob/totalM3',
	'bedc:report:read:column/timePerJob/totalM2DividedByTotalTimeInMotion',
	'bedc:report:read:column/timePerJob/totalM3DividedByTotalTimeInMotion',

	'bedc:report:read:column/timePerJob/volumetricsUniqTrussTypesFloor',
	'bedc:report:read:column/timePerJob/volumetricsUniqTrussTypesRoof',
	'bedc:report:read:column/timePerJob/volumetricsUniqTrussTypesRafters',

	'bedc:report:read:{clientId}/myTimePerJob',
	'bedc:report:read:{clientId}/completedJobsByRequirements',
	'bedc:report:read:{clientId}/completedJobsByAssignee',
	'bedc:report:read:{clientId}/myCompletedJobsByAssignee',
	'bedc:report:read:{clientId}/completedJobsByDate',
	'bedc:report:read/allCustomers',

	'bedc:report:read:{clientId}/bedcCompletedJobsByDate',
	'bedc:report:read:column/bedcCompletedJobsByDate/customer',
	'bedc:report:read:column/bedcCompletedJobsByDate/targetAt',
	'bedc:report:read:column/bedcCompletedJobsByDate/volumetricsTotalFloorCount',
	'bedc:report:read:column/bedcCompletedJobsByDate/volumetricsTotalRoofCount',
	'bedc:report:read:column/bedcCompletedJobsByDate/allocatedAt',

	'bedc:report:read:{clientId}/featuresByClient',
	'bedc:report:read:{clientId}/workOverdue',

	'bedc:report:read:{clientId}/completedTransactionsMyReview',
	'bedc:report:read:{clientId}/completedTransactionsTeamReview',
	'bedc:report:read:{clientId}/completedTransactionsTeamMemberReview',

	// bedc specific cols
	// non bedc specific cols

	// Design Transactions (v2) — report-access + GENERALIZED, report-agnostic column perms
	// (no report name in the column-perm string, so they're shared across reports)
	'bedc:report:read:{clientId}/designTransactions',
	'bedc:report:read:column/transactionTargetAt',
	'bedc:report:read:column/uniqTrussTypes',
	'bedc:report:read:column/ownerName', // allows all owner names
	'bedc:report:read:column/aiFeedbackFormData',
	'bedc:report:read:column/nonBedcOwnerName', // allows non bedc owner names only
	// Pricing invoice columns + the invoice detail/export routes. The country
	// configuration must also feature the column (report.designTransactions).
	'bedc:report:read:column/designTransactions/mtoInvoice',

	// Usage Reports (admin-only) — monthly data-warehouse usage metrics. Granted
	// only via the bedc-report-admin role (system-admin / rome-dev). `{clientId}`
	// scope so admins auto-bypass per-org feature flags via skipFeatures.
	'bedc:report:read:{clientId}/usageReports',

	// this is client specific report skipFeatures is not used for this report
	'bedc:report:read:{organizationId}/bigRiverGeelongCompletedJobsByDate',
	'bedc:report:read:{organizationId}/estimateOutcome',
	'bedc:report:read:{organizationId}/estimateOutcomeTrx',

	// allows user to skip the client feature flags [typically used fro BEDC users]
	'bedc:report:read:{clientId}/skipFeatures',
] as const;
